import type { XentrosAuthProvider } from "./AuthProvider.interface";
import { localAuthProvider } from "./localAuthProvider";
import { usmAuthProvider } from "./usmAuthProvider";

const configuredProvider = (import.meta.env.VITE_AUTH_PROVIDER as string | undefined)?.trim().toLowerCase();
const configuredLocalLoginOverride = (import.meta.env.VITE_ALLOW_LOCAL_LOGIN as string | undefined)?.trim().toLowerCase();

// In production builds the local provider is NEVER active — USM is always the authority.
// In development, "local" is the fallback when VITE_AUTH_PROVIDER is not explicitly "usm",
// so the app can run without a live USM instance during development.
export const AUTH_PROVIDER_KEY = (import.meta.env.PROD || configuredProvider === "usm")
  ? "usm"
  : "local" as const;

export const ACTIVE_AUTH_PROVIDER: XentrosAuthProvider = AUTH_PROVIDER_KEY === "usm"
  ? usmAuthProvider
  : localAuthProvider;

function isLoopbackHost(hostname: string) {
  return hostname === "localhost"
    || hostname === "127.0.0.1"
    || hostname === "::1"
    || hostname.endsWith(".localhost");
}

export function isLocalPasswordLoginEnabled() {
  if (configuredLocalLoginOverride === "true") return true;
  if (configuredLocalLoginOverride === "false") return false;
  if (AUTH_PROVIDER_KEY === "usm") return true;
  if (AUTH_PROVIDER_KEY === "local") return true;
  if (import.meta.env.DEV) return true;
  if (typeof window === "undefined") return false;

  const { protocol, hostname } = window.location;
  return protocol === "tauri:" || isLoopbackHost(hostname);
}

export function getPasswordLoginProvider(): XentrosAuthProvider {
  if (AUTH_PROVIDER_KEY === "usm") return usmAuthProvider;
  return localAuthProvider;
}

export { localAuthProvider, usmAuthProvider };
